import { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import Input from '../components/input/input';

class SignUp extends PureComponent {
  state = {
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    isValid: true,
    errors: null,
  };

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onClose() {
    this.setState({ errors: null });
  }

  async onSubmit() {
    const { name, email, password, confirmPassword } = this.state;

    if (this.isValid()) {
      this.props.onSignUp({ data: { name, email, password, confirmPassword } });
    } else {
      this.setState({ isValid: this.isValid() });
      window.scrollTo(0, 0);
    }
  }

  isValid() {
    const { email, password } = this.state;
    return email !== '' && password !== '';
  }

  render() {
    const { name, email, password, confirmPassword, isValid, errors } =
      this.state;

    const messageBox = errors && (
      <div className="errors">
        {errors &&
          errors.map((error, index) => (
            <span key={index}>{error.message}</span>
          ))}
      </div>
    );

    return (
      <main className="th-main">
        <section className="th-canvas">
          <header className="th-canvas-header"></header>
          <div>
            <div className="auth">
              <div className="header">
                <h1>Sign Up</h1>
              </div>
              {messageBox}
              <div className="w-100 flex flex-column items-start justify-between">
                <div className="w-100">
                  <Input
                    name="name"
                    label="Name*"
                    value={name}
                    valid={isValid || name !== ''}
                    onChange={(event) => this.onChange(event)}
                  />
                </div>
                <div className="w-100">
                  <Input
                    name="email"
                    label="Email*"
                    value={email}
                    valid={isValid || email !== ''}
                    onChange={(event) => this.onChange(event)}
                  />
                </div>
                <div className="w-100">
                  <Input
                    name="password"
                    type="password"
                    label="Password*"
                    value={password}
                    valid={isValid || password !== ''}
                    onChange={(event) => this.onChange(event)}
                  />
                </div>
                <div className="w-100">
                  <Input
                    name="confirmPassword"
                    type="password"
                    label="Confirm password*"
                    value={confirmPassword}
                    valid={isValid || password !== ''}
                    onChange={(event) => this.onChange(event)}
                  />
                </div>
              </div>
              <Link className="fr" to="/sign_in">
                Sign in
              </Link>
              <div className="action">
                <button
                  className="btn-green"
                  data-cy="submit"
                  onClick={() => this.onSubmit()}
                >
                  Sign up
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default SignUp;
